import { FeaturedIcon, Modal } from '@unified-checkout/design-system';
import {
  CommentsQuestionCheck,
  TrashCan,
} from '@unified-checkout/design-system/icons/index';
import { Key } from 'apps/customer/src/assets/icons';
import { DeviceContext } from 'apps/customer/src/context/device';
import {
  useDeleteAccount,
} from 'apps/customer/src/services/inner_layout/auth';
import { useContext, useState } from 'react';
import { SingleCard } from './SingleCard';
import { useNavigate } from 'react-router-dom';
import { logoutHandler } from 'apps/customer/src/utils';
import { EditContactForm } from './EditContactForm';
import { useQueryClient } from '@tanstack/react-query';
export const Setting = () => {
  const navigator = useNavigate();

  const { mutate: deleteAccountMutation } = useDeleteAccount();
  const queryClient = useQueryClient();

  const { isMobile } = useContext(DeviceContext);

  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] =
    useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const deleteAccountHandler = () => {
    deleteAccountMutation();
    setIsDeleteAccountModalOpen(false);
  };

  const deleteModalCloseHandler = () => {
    setIsDeleteAccountModalOpen(false);
  };

  const LogoutModalCloseHandler = () => {
    setIsLogoutModalOpen(false);
  };

  return (
    <section className="flex flex-col pb-5 grow">
      <h2 className="page-title">Settings</h2>
      <section className="flex flex-col grow ">
        <EditContactForm />
        <section className="mt-5 md:mt-4">
          <p className="mb-3 english-utility-label-medium">Security</p>
          <SingleCard
            icon={Key}
            text="Add a passkey"
            title="Passkey"
            onClickHandler={() => navigator('/passkeys')}
          />
        </section>
        <section className="mt-5">
          <p className="mb-3 english-utility-label-medium">Other</p>
          <SingleCard
            icon={CommentsQuestionCheck}
            title="FAQ's"
            onClickHandler={() => navigator('/faqs')}
          />
        </section>
        <section className="mt-auto space-y-2">
          <SingleCard
            titleColor="red"
            title="Delete Account"
            withoutChevron
            onClickHandler={() => setIsDeleteAccountModalOpen(true)}
          />
          {isDeleteAccountModalOpen && (
            <Modal
              open={isDeleteAccountModalOpen}
              isMobile={isMobile}
              headerIcon={
                <FeaturedIcon icon={TrashCan} color="red" size="xl" />
              }
              title="Are you sure you want to delete your account"
              supportingText="All your data will be lost by deleting your account"
              btnsProps={[
                {
                  color: 'primary',
                  text: 'Cancel',
                  onClickHandler: () => setIsDeleteAccountModalOpen(false),
                },
                {
                  color: 'secondary',
                  text: 'Delete account anyways',
                  variant: 'outlined',
                  onClickHandler: () => deleteAccountHandler(),
                },
              ]}
              closeOnClickOutside
              onCloseHandler={deleteModalCloseHandler}
            />
          )}
          <SingleCard
            titleColor="lightGray"
            title="Logout"
            withoutChevron
            onClickHandler={() => setIsLogoutModalOpen(true)}
          />
          {isLogoutModalOpen && (
            <Modal
              open={isLogoutModalOpen}
              isMobile={isMobile}
              headerIcon={
                <FeaturedIcon icon={TrashCan} color="red" size="xl" />
              }
              title="Are you sure you want to logout?"
              supportingText="You will have to login for 1-click checkout for payments if you logout"
              btnsProps={[
                {
                  color: 'primary',
                  text: 'Cancel',
                  onClickHandler: () => LogoutModalCloseHandler(),
                },
                {
                  color: 'secondary',
                  text: 'Logout',
                  variant: 'outlined',
                  onClickHandler: () => logoutHandler(queryClient),
                },
              ]}
              closeOnClickOutside
              onCloseHandler={LogoutModalCloseHandler}
            />
          )}
        </section>
      </section>
    </section>
  );
};
